module.exports = __webpack_public_path__ + "img/波棱瓜子.1809ea2e.jpg";